"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.optionalFields = exports.imagesFields = exports.getFormInitialValuesKeys = exports.getFormExtraFields = exports.default = exports.baseFields = void 0;
var _core = require("@material-ui/core");
var _formik = require("formik");
var _react = _interopRequireDefault(require("react"));
var _BaseForm = _interopRequireDefault(require("react-platform-components/dist/BaseComponents/BaseForm"));
var _BaseInjectors = require("react-platform-components/dist/BaseComponents/BaseInjectors");
var _formFields = require("react-platform-components/dist/form-fields");
var _formValidators = require("react-platform-components/dist/form-validators");
var _Translations = require("react-platform-components/dist/Translations");
var _uploader = require("react-platform-components/dist/uploader");
var _config = require("../../config");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var CategoryOfProductField = null;
try {
  CategoryOfProductField = _config.USE_SINGLE_LEVEL_FIELD_OF_CATEGORY ? require('react-platform-category-of-product/dist/CategoryOfProduct/CategoryOfProductSingleLevelField').default : require('react-platform-category-of-product/dist/CategoryOfProduct/CategoryOfProductField').default;
} catch (error) {
  console.log('errror categori of product');
}
var SpecificitiesOfProductFields = null;
try {
  SpecificitiesOfProductFields = require('react-platform-specificity-of-product/dist/SpecificityOfProduct/SpecificitiesOfProductFields').default;
} catch (error) {
  console.log('errror SpecificitiesOfProductFields');
}
var OptionOfProductField = null;
try {
  OptionOfProductField = require('react-platform-option-of-product/dist/OptionOfProduct/OptionOfProductField').default;
} catch (error) {
  console.log('errror categori of OptionOfProductField');
}
var AddressOfProductFields;
try {
  AddressOfProductFields = require('react-platform-address-of-product/dist/AddressOfProduct/AddressOfProductFields').default;
} catch (error) {}
var baseFields = function baseFields(props, prefix) {
  var prfx = prefix || '';
  return [/*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/_react.default.createElement(_formFields.TextField, {
    name: "".concat(prfx, "name"),
    label: "Titre",
    margin: "normal",
    variant: "outlined",
    fullWidth: true,
    required: true,
    validate: (0, _formValidators.required)()
  })), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/_react.default.createElement(_formFields.TextField, {
    name: "".concat(prfx, "description"),
    label: "Description",
    margin: "normal",
    variant: "outlined",
    multiline: true,
    rows: 3,
    fullWidth: true,
    required: true,
    validate: (0, _formValidators.validators)([(0, _formValidators.required)()])
  }))];
};
exports.baseFields = baseFields;
var optionalFields = function optionalFields(props, prefix) {
  var fields = [];
  {
    CategoryOfProductField && fields.push( /*#__PURE__*/_react.default.createElement(CategoryOfProductField, props));
  }
  {
    SpecificitiesOfProductFields && fields.push( /*#__PURE__*/_react.default.createElement(SpecificitiesOfProductFields, props));
  }
  {
    OptionOfProductField && fields.push( /*#__PURE__*/_react.default.createElement(OptionOfProductField, props));
  }
  {
    AddressOfProductFields && fields.push( /*#__PURE__*/_react.default.createElement(AddressOfProductFields, props));
  }
  return fields;
};
exports.optionalFields = optionalFields;
var imagesFields = function imagesFields(props, prefix) {
  var prfx = prefix || '';
  return [/*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    item: true,
    xs: 12,
    justify: "center"
  }, /*#__PURE__*/_react.default.createElement(_formik.Field, {
    name: "".concat(prfx, "images"),
    label: "Images *",
    value: props.values.images
    // maxImages={2}
    // maxTotalSize={1000000}
    ,
    acceptedFiles: "image/bmp,image/gif,image/jpeg,image/png,image/x-ms-bmp",
    component: _uploader.renderMultiImagesField,
    validate: (0, _formValidators.required)(),
    required: true,
    onDelete: function onDelete(id) {
      return props.setFieldValue('images-to-delete', props.values.imagesToDelete ? [].concat(_toConsumableArray(props.values.imagesToDelete), [id]) : [id]);
    }
  }))];
};

// Return an array of fields
exports.imagesFields = imagesFields;
var getFormExtraFields = function getFormExtraFields(props, prefix) {
  var formExtraFields = [];
  formExtraFields.push(baseFields(props, prefix));
  formExtraFields.push(optionalFields(props, prefix));
  formExtraFields.push(imagesFields(props, prefix));
  return formExtraFields;
};

// Return an array of field keys
exports.getFormExtraFields = getFormExtraFields;
var getFormInitialValuesKeys = function getFormInitialValuesKeys(prefix) {
  var prfx = prefix || '';
  var initialValuesKeys = ["".concat(prfx, "name"), "".concat(prfx, "description"), "".concat(prfx, "images")];
  {
    CategoryOfProductField && initialValuesKeys.push('category');
  }
  {
    SpecificitiesOfProductFields && initialValuesKeys.push('specificities');
  }
  {
    OptionOfProductField && initialValuesKeys.push('options');
  }
  {
    AddressOfProductFields && initialValuesKeys.push('address');
  }
  return initialValuesKeys;
};

// Create a form component from BaseForm
exports.getFormInitialValuesKeys = getFormInitialValuesKeys;
var _default = (0, _BaseInjectors.injectToForm)(_BaseForm.default, {
  // Pass the function that will return the array of fields
  formExtraFields: function formExtraFields(props) {
    return getFormExtraFields(props);
  },
  // Pass function that will create and object of key/value pairs from the
  // array of field keys
  handleInitialValues: function handleInitialValues(props) {
    return Object.assign.apply(Object, [{}].concat(_toConsumableArray(getFormInitialValuesKeys().map(function (key) {
      if (key === 'category') {
        return _defineProperty({}, key, props.product && props.product[key] && props.product[key].id || '');
      } else if (key === 'specificities') {
        return _defineProperty({}, key, props.product && props.product['product_specificities'] || '');
      } else if (key === 'address') {
        var obj = {
          'address-address_01': '',
          'address-city': '',
          'address-state': '',
          'address-country': ''
        };
        if (props.product && props.product.address) {
          if (props.product.address.address_01) {
            obj['address-address_01'] = props.product.address.address_01;
          }
          if (props.product.address.city) {
            obj['address-city'] = props.product.address.city.id;
            if (props.product.address.city.state) {
              obj['address-state'] = props.product.address.city.state.id;
              if (props.product.address.city.state.country) {
                obj['address-country'] = props.product.address.city.state.country.id;
              }
            }
          }
        }
        return obj;
      } else {
        return _defineProperty({}, key, props.product && props.product[key] || '');
      }
    }))));
  }
});
exports.default = _default;